var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #717402;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(-474 1011)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    className: "cls-1",
    width: 200,
    height: 200,
    transform: "translate(474 -1011)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-calendar",
    "data-name": "Icon feather-calendar",
    transform: "translate(487.217 -1005.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    className: "cls-2",
    d: "M22.267-2.5H151.3a26.3,26.3,0,0,1,26.267,26.267V152.8A26.3,26.3,0,0,1,151.3,179.067H22.267A26.3,26.3,0,0,1-4,152.8V23.767A26.3,26.3,0,0,1,22.267-2.5ZM151.3,163.4a10.611,10.611,0,0,0,10.6-10.6V23.767a10.611,10.611,0,0,0-10.6-10.6H22.267a10.611,10.611,0,0,0-10.6,10.6V152.8a10.611,10.611,0,0,0,10.6,10.6Z",
    transform: "translate(0 15.433)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    className: "cls-2",
    d: "M23.334,47.035A7.834,7.834,0,0,1,15.5,39.2V2.334a7.834,7.834,0,1,1,15.668,0V39.2A7.834,7.834,0,0,1,23.334,47.035Z",
    transform: "translate(100.316 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    className: "cls-2",
    d: "M11.334,47.035A7.834,7.834,0,0,1,3.5,39.2V2.334a7.834,7.834,0,1,1,15.668,0V39.2A7.834,7.834,0,0,1,11.334,47.035Z",
    transform: "translate(38.583 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    className: "cls-2",
    d: "M169.733,22.168H3.834a7.834,7.834,0,1,1,0-15.668h165.9a7.834,7.834,0,1,1,0,15.668Z",
    transform: "translate(0 61.733)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.1ae3bab7a5201b1720baf877e229055b.svg";
export { ForwardRef as ReactComponent };